import { SelectProps } from 'baseui/select';
import { ReactNode } from 'react';
import { BaseCustomFormProps } from '../../Utilities/types/SharedProps';

export interface SelectHTMLAttributes {
	form?: string;
}

export const TYPE = {
	select: 'select',
	search: 'search',
};

export const SIZE = {
	default: 'default',
	compact: 'compact',
	large: 'large',
};

export interface Option {
	readonly id?: string | number;
	readonly label?: React.ReactNode;
	readonly disabled?: boolean;
	readonly clearableValue?: boolean;
	readonly isCreatable?: boolean;
	readonly __optgroup?: string;
	[others: string]: any;
}

export type Value = ReadonlyArray<Option>;
export type OptgroupsT = { __ungrouped: Value; [key: string]: Value };
export type OptionsT = Value | OptgroupsT;

interface STATE_CHANGE_TYPE {
	select: 'select';
	remove: 'remove';
	clear: 'clear';
}

export interface OnChangeParams {
	value: Value;
	option?: Option;
	type?: STATE_CHANGE_TYPE[keyof STATE_CHANGE_TYPE];
}

// // Dummy and Smart shared props
export interface ISharedOwnProps {
	/**
	 * An icon rendered at the start of the select in search mode
	 */
	icon?: string;
	/**
	 * A component rendered at the start of the options
	 */
	itemBefore?: any;
	/**
	 * End enhancer for the option items.
	 */
	itemAfter?: any;
	/**
	 * Placeholder  when items selected for preset: multi
	 */
	textMultiSummary?: ReactNode;
	/**
	 * Different configurations of the component
	 */
	preset?: 'select' | 'combo' | 'multi-tags' | 'multi' | 'creatable';
	/**
	 * Defines if the control is not editable.
	 */
	readOnly?: boolean;
	/**
	 * Object for adding properties to the dropdown
	 */
	PopoverProps?: object;
	/**
	 * Object for adding properties to the dropdown
	 */
	PopoverBodyProps?: object;

	/**
	 * Add or override styles in the dropdown control container
	 */
	ControlContainerStyle?: object;

	/**
	 * Add or override styles in the dropdown container
	 */
	DropdownContainerStyle?: object;

	/**
	 * Add or override styles in the dropdown
	 */
	DropdownStyle?: object;

	/**
	 * Add or override styles in the icon container
	 */
	IconsContainerStyle?: object;

	/**
	 * A component rendered at the top of the dropdown pop-up
	 */
	dropdownTopElement?: any;

	/**
	 * A component rendered at the bottom of the dropdown pop-up
	 */
	dropdownBottomElement?: any;

	/**
	 * A custom method to get a display value for a dropdown option.
	 * Type: ({option}) => option.label
	 */
	getOptionLabel?: ({ option: any }: any) => any;
}

type ISharedExternalProps = SelectProps; // External libraries props shared between smart and dummy

type ISharedProps = ISharedOwnProps & BaseCustomFormProps;

/**
 * ---------------------------------
 * Smart Component types
 * ---------------------------------
 */
export type ISmartProps = ISmartCustomProps & ISharedExternalProps;
export type ISmartCustomProps = ISmartOwnProps & ISharedProps;

// Props to pass and be only used by smart component
export interface ISmartOwnProps {}

export type ISmartState = ISmartOwnState & ISmartOwnStateToDummyProps;

// State to be defined and used only inside smart component (i.e., to calculate other internal states and/or dummy props)
interface ISmartOwnState {}

// Smart state to be passed to dummy through its props
export interface ISmartOwnStateToDummyProps {}

/**
 * ---------------------------------
 *  Dummy Component types
 * ---------------------------------
 */
export type IDummyProps = IDummyOwnProps & ISmartOwnStateToDummyProps & ISharedProps & ISharedExternalProps & IHandlers;

export interface IDummyOwnProps {
	badge?: boolean;
}

/**
 * ---------------------------------
 * Types for event handlings
 * ---------------------------------
 */
export interface IHandlers {
	// onChangeHandler: SelectProps['onChange'];
}
